import { useState } from "react";

import { useFieldArray, useFormContext } from "react-hook-form";

import { Delete as DeleteIcon, Edit as EditIcon } from "@mui/icons-material";
import { Button, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";

import { SupplierContactForm } from "./supplier-contact-form";

export const SupplierContactSection = () => {
  const { control } = useFormContext();
  const {
    fields: supplierContacts,
    append,
    update,
    remove,
  } = useFieldArray({
    control,
    name: "supplierContacts",
  });
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  const rows = supplierContacts.map((contact, index) => ({
    ...contact,
    index,
  }));

  const columns = [
    { field: "name", headerName: "Nama", flex: 1.5, sortable: false },
    { field: "position", headerName: "Jabatan", flex: 1.5, sortable: false },
    {
      field: "email",
      headerName: "Email",
      flex: 2,
      sortable: false,
      renderCell: ({ row }) => row.email || "-",
    },
    {
      field: "phoneNumber",
      headerName: "No. HP",
      flex: 1.5,
      sortable: false,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Aksi",
      width: 100,
      getActions: ({ row }) => [
        <GridActionsCellItem
          key="edit"
          icon={<EditIcon />}
          label="Ubah"
          onClick={() => setEditIndex(row.index)}
        />,
        <GridActionsCellItem
          key="delete"
          icon={<DeleteIcon />}
          label="Hapus"
          color="error"
          onClick={() => remove(row.index)}
        />,
      ],
    },
  ];

  return (
    <>
      <Grid container spacing={3}>
        <Grid size={12}>
          <Stack
            direction="row"
            sx={{
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h6">Kontak</Typography>
            <Button variant="outlined" onClick={() => setIsAddDialogOpen(true)}>
              Tambah
            </Button>
          </Stack>
        </Grid>
        <Grid size={12}>
          <DataGrid
            rows={rows}
            columns={columns}
            getRowHeight={() => "auto"}
            disableRowSelectionOnClick
            disableColumnMenu
            hideFooter
            localeText={{ noRowsLabel: "Belum ada kontak." }}
          />
        </Grid>
      </Grid>
      {/* Add */}
      {isAddDialogOpen && (
        <SupplierContactForm
          onClose={() => setIsAddDialogOpen(false)}
          onSubmit={(data) => {
            append(data);
            setIsAddDialogOpen(false);
          }}
        />
      )}
      {/* Edit */}
      {editIndex != null && (
        <SupplierContactForm
          defaultValues={supplierContacts[editIndex]}
          onClose={() => setEditIndex(null)}
          onSubmit={(data) => update(editIndex, data)}
        />
      )}
    </>
  );
};

export default SupplierContactSection;
